import { ReduxStore } from 'store/types';

function createIsLoading(state: ReduxStore): boolean {
  return state.manufacturer.create.config.isLoading;
}

export default createIsLoading;
